module.exports = __webpack_public_path__ + "static/logo-horizontal-white-b18251ce42fad1ec383046aaa9c5bf92.png";